module.exports = __webpack_public_path__ + "img/logo.5e06a80c.png";